import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PasswordResetDialogData } from '../../models/PasswordResetDialogData';

@Component({
  selector: 'app-invalid-token-dialog',
  templateUrl: './invalid-token-dialog.component.html',
  styleUrls: ['./invalid-token-dialog.component.scss']
})
export class InvalidTokenDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<InvalidTokenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PasswordResetDialogData,
    ) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  getTitle(){
    return "Invalid data"; 
  }
  getContent(){
    return this.data.errorMessage; 
  }

}
